/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';

/**
 * 
 * @export
 * @interface LatestEnrichedEquityUniverse
 */
export interface LatestEnrichedEquityUniverse {
    /**
     * 
     * @type {string}
     * @memberof LatestEnrichedEquityUniverse
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof LatestEnrichedEquityUniverse
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof LatestEnrichedEquityUniverse
     */
    coId?: string;
    /**
     * 
     * @type {string}
     * @memberof LatestEnrichedEquityUniverse
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof LatestEnrichedEquityUniverse
     */
    description?: string;
    /**
     * 
     * @type {AssetType}
     * @memberof LatestEnrichedEquityUniverse
     */
    assetType: AssetType;
    /**
     * 
     * @type {number}
     * @memberof LatestEnrichedEquityUniverse
     */
    marketCap?: number;
    /**
     * 
     * @type {number}
     * @memberof LatestEnrichedEquityUniverse
     */
    marketCapWeight?: number;
}



/**
 * Check if a given object implements the LatestEnrichedEquityUniverse interface.
 */
export function instanceOfLatestEnrichedEquityUniverse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "assetType" in value;

    return isInstance;
}

export function LatestEnrichedEquityUniverseFromJSON(json: any): LatestEnrichedEquityUniverse {
    return LatestEnrichedEquityUniverseFromJSONTyped(json, false);
}

export function LatestEnrichedEquityUniverseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestEnrichedEquityUniverse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': json['s_id'],
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'coId': !exists(json, 'co_id') ? undefined : json['co_id'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'marketCap': !exists(json, 'market_cap') ? undefined : json['market_cap'],
        'marketCapWeight': !exists(json, 'market_cap_weight') ? undefined : json['market_cap_weight'],
    };
}

export function LatestEnrichedEquityUniverseToJSON(value?: LatestEnrichedEquityUniverse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's_id': value.sId,
        'sc_id': value.scId,
        'co_id': value.coId,
        'symbol': value.symbol,
        'description': value.description,
        'asset_type': AssetTypeToJSON(value.assetType),
        'market_cap': value.marketCap,
        'market_cap_weight': value.marketCapWeight,
    };
}

